const chatMemberList = [];

const chatMessages = [];

const profileDetail =
{
};

const contacts = [
];

const groups = [
 
]

export { chatMemberList, chatMessages, profileDetail, contacts, groups };